
<style lang="sass" scoped>
.none_history_order
  display: flex
  flex-direction: column
  align-items: center
  margin-top: 32px
  font-size: 12px
  color: rgba(51, 68, 85, .75)
  letter-spacing: 0.6px

  .icon_container
    .icon
      height: 67px

  .title
    margin-top: 18px
    font-size: 16px
    color: #334455
    font-weight: bold

  .text
    margin-top: 14px

  .to_login
    padding: 6px
    font-weight: bold
    color: var(--menu-primary-background-colour)
</style>

<template lang="pug">
.none_history_order
  .icon_container
    img.icon(:src="lockSrc")
  .title {{ noOrderHistoryTitle }}
  p.text {{ noOrdersPlacedYet }}
  p.text {{ orderedFromVenueBefore }}
  .to_login(@click="toLogin") {{ retrieveFullOrderHistory }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapState } from 'vuex'
import { t } from '@/utils/language'

@Component({
  computed: {
    ...mapState(['venueId'])
  }
}
)

class NoneHistoryOrder extends Vue {
  lockSrc = require('@/assets/order.png')

  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  get noOrderHistoryTitle() {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t('no_order_history_title', 'No order history')
  }

  get noOrdersPlacedYet() {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t('no_orders_placed_yet', 'You have not placed any orders yet.')
  }

  get orderedFromVenueBefore() {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t('ordered_from_venue_before', 'Ordered from this venue before?')
  }

  get retrieveFullOrderHistory() {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t('retrieve_full_order_history', 'Retrieve your full order history')
  }

  toLogin() {
    this.$router.push(`/v/${this.venueId}/login/enter-phone-number`)
  }
}

export default NoneHistoryOrder
</script>
